import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { PRICING_CONFIGURATION_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const pricingConfigurationReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case PRICING_CONFIGURATION_ACTION_TYPE.GET_CONFIGURATION:
        return payload || initialState;

      case PRICING_CONFIGURATION_ACTION_TYPE.EDIT_CONFIGURATION:
      case PRICING_CONFIGURATION_ACTION_TYPE.CREATE_CONFIGURATION:
        return payload || state;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default pricingConfigurationReducer;
